/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchNotificationDataParser = 
/* #__PURE__ */ parsers.object([['read', codecBoolean]]);
export class PatchNotificationData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchNotificationDataParser.decode(input).map(res => new PatchNotificationData(res));
    }
    static unsafeDecode(input) {
        return PatchNotificationData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchNotificationDataParser.encode(data);
    }
    static schema() {
        return PatchNotificationDataParser.schema();
    }
}
